import React from 'react';
import { MapPin, Linkedin } from 'lucide-react';
import { Link } from 'react-router-dom';

const Footer = () => {
  return (
    <footer className="bg-slate-950 text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid md:grid-cols-4 gap-12">
          {/* Company Info */}
          <div className="md:col-span-2">
            <img
              src={process.env.REACT_APP_LOGO_URL}
              alt="Cautela Defence Services"
              className="h-10 w-auto mb-6" />

            <p className="text-slate-400 mb-6 leading-relaxed">
              Cautela Defence Services Ltd is a specialist UK-based cyber assurance consultancy dedicated to helping government and their supply chain organisations build and maintain secure, resilient digital capabilities.
            </p>
          </div>

          {/* Quick Links */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Quick Links</h3>
            <ul className="space-y-3">
              <li>
                <a href="#capabilities" className="text-slate-400 hover:text-cautela-green transition-colors duration-200">
                  Capabilities
                </a>
              </li>
              <li>
                <a href="#contact" className="text-slate-400 hover:text-cautela-green transition-colors duration-200">
                  Contact
                </a>
              </li>
              <li>
                <Link to="/privacy-policy" className="text-slate-400 hover:text-cautela-green transition-colors duration-200">
                  Privacy Policy
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact Info */}
          <div>
            <h3 className="text-lg font-semibold mb-4">Get in Touch</h3>
            <ul className="space-y-3">
              <li className="flex items-start gap-3">
                <MapPin className="text-cautela-green flex-shrink-0 mt-1" size={18} />
                <span className="text-slate-400">United Kingdom</span>
              </li>
            </ul>
          </div>
        </div>

        {/* Bottom Bar */}
        <div className="border-t border-slate-800 mt-12 pt-8 flex flex-col md:flex-row justify-between items-center gap-4">
          <p className="text-slate-500 text-sm">
            © {new Date().getFullYear()} Cautela Defence Services Ltd. All rights reserved.
          </p>
          <div className="flex gap-4">
            <a href="#" className="text-slate-400 hover:text-cautela-green transition-colors duration-200">
              <Linkedin size={20} />
            </a>
          </div>
        </div>
      </div>
    </footer>);

};

export default Footer;